import React from 'react';
import { Link } from 'react-router-dom';

import SectionTitle from '../../components/Common/SectionTitle';
import ProgressBar from '../../components/Elements/Progress/ProgressBar';

// Sobre Image
import AboutImage from '../../assets/img/about/about-5.png';

const AboutTwo = (props) => {

    return (
        <div className="rs-about style2 modify1 black-dark pt-120 pb-120 md-pt-70 md-pb-80">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 hidden-md">
                        <div className="images">
                            <img
                                src={AboutImage}
                                alt="about"
                            /> 
                        </div>
                    </div>
                    <div className="col-lg-6 pl-60 md-pl-14">
                        {/* Section Title Start */}
                        <SectionTitle
                            sectionClass="sec-title mb-30"
                            subtitleClass="sub-text white-color style4-bg"
                            subtitle="Sobre a Ayit"
                            titleClass="title white-color pb-20"
                            title="Nossa missão:  promover a expansão de Negócios de Sucesso com o uso da Tecnologia"
                            descClass="desc white-color"
                            description="Apoiamos dezenas de empresas usando as melhores tecnologias para escalar seus negócios digitais."
                        />
                        {/* Section Title End */}
                        <div className="rs-skillbar style1 home4">
                            <ProgressBar
                                completed={42}
                                height={7}
                                boxbg={"#eeeeee"}
                                figurebg={"#FD6509"}
                                labelColor={"#ffffff"}
                                countColor={"#ffffff"}
                                ProgressBox="progress-box"
                                ProgressFigure="progress-figure"
                                ProgressCount="Progress-count"
                                ProgressLabel="progress-label"
                                label="Sistemas Financeiros (Bancos, Fintechs, Real State Techs...)"
                                ProgressParent="main-div"
                            />
                            <ProgressBar
                                completed={27}
                                height={7}
                                boxbg={"#eeeeee"}
                                figurebg={"#0A99FD"}
                                labelColor={"#ffffff"}
                                countColor={"#ffffff"}
                                ProgressBox="progress-box"
                                ProgressFigure="progress-figure"
                                ProgressCount="Progress-count"
                                ProgressLabel="progress-label"
                                label="Autoatendimento (ATMs de Saques e Recargas)"
                                ProgressParent="main-div"
                            />
                            <ProgressBar
                                completed={23}
                                height={7}
                                boxbg={"#eeeeee"}
                                figurebg={"#F00674"}
                                labelColor={"#ffffff"}
                                countColor={"#ffffff"}
                                ProgressBox="progress-box"
                                ProgressFigure="progress-figure"
                                ProgressCount="Progress-count"
                                ProgressLabel="progress-label"
                                label="Desenvolvimento Web (Internet Banking e Portais Institucionais)"
                                ProgressParent="main-div"
                            />                            
                            <ProgressBar
                                completed={8}
                                height={7}
                                boxbg={"#eeeeee"}
                                figurebg={"#FD6509"}
                                labelColor={"#ffffff"}
                                countColor={"#ffffff"}
                                ProgressBox="progress-box"
                                ProgressFigure="progress-figure"
                                ProgressCount="Progress-count"
                                ProgressLabel="progress-label"
                                label="Mobile Apps e IoT"
                                ProgressParent="main-div"
                            />                            
                            {/*<div className="btn-part mt-46">
                                <Link className="readon started" to="/about">Get Started</Link>
    </div>*/}
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutTwo;